import { useState } from 'react';
import './App.css';
import PickArea from './components/PickArea';
import Podium from './components/Podium';

function App() {
  const [slotList, setSlotList] = useState([]);
  const girlsList = "nana,dohwa,riina,miru,bora,sangah,seoyeon,soeun,suyun,soojin,elly,yeoreum,yeonhee,yeeun,wooyeon,yuki,zoa,jooe,juri,jiwoo,jiwon,jihan,chaerin,kei,fye,hwiseo".split(",");

  let [availableGirls, setAvailableGirls] = useState([...girlsList]);
  let [clicked, setClicked] = useState(false);
  let [selected, setSelected] = useState('');
  
  function updateSlotList(girl, elId) {
      setSlotList(prev => {
      let updated = [...prev];
        updated[elId] = selected;
        return updated;
      });
  }

  function updateAvailableGirls(girl, elId) {
    if (slotList[elId]) {
      setAvailableGirls(prev => {
        return [...prev, slotList[elId]].filter(name => name != girl);
      })
    } else {
      setAvailableGirls([...availableGirls].filter(el => el != girl));
    }
  }

  function handleClick(e) {
    if (!e.target.classList.contains('unavailable')) {
      if (!clicked) {
        setSelected(e.target.id)
        setClicked(clicked)
      } else {
        setClicked(!clicked)
      }
    }
  }

  function handleSlotClick(e, id) {
    if (selected && availableGirls.includes(selected)) {
      if (!e.target.classList.contains('hidden')) {
        e.target.classList = `square picked ${selected}`;
        updateAvailableGirls(selected, id);
        updateSlotList(selected, id);        
      }
    }
  }
  
  return (
    <div className="App">
      <h1 className="mainTitle">My QUEENDOM PUZZLE <strong className="highlighted">Girl Group</strong></h1>
      <Podium 
        handleSlotClick={handleSlotClick}
        slotList={slotList}
        girlPicked={selected}
        />
      <PickArea 
        girlsList={girlsList} 
        availableGirls={availableGirls}
        handleClick={handleClick}
        selected={selected}
        />
    </div>
  );
}

export default App;
